var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-column min-vh-100 position-relative",attrs:{"id":"main"}},[_c('HeaderPlagiarismChecker',{staticClass:"mb-3"}),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('Footer',{attrs:{"footer-links":_vm.footerLinks,"gray-theme":true}})],1),_vm._v(" "),_c('PortalTarget',{attrs:{"name":"modal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }